import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";
import AdminSidebar from "../../layouts/AdminSidebar";
import { authCall } from "../../../services";
import AppConstants from "../../../appConstants";

function ArchivesDailyDealsPage() {
  const location = useLocation();
  const pathname = location.pathname;
  const isArchivedList =
    AppConstants.routes.admin.archivedEvents.includes(pathname);
  const [goalList, setGoalList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const resp = await authCall("getDailyDeals", {
        isArchived: true,
      });
      if (resp?.type === "success") {
        setGoalList(resp?.payload);
        setLoading(false);
      }
    }
    fetchData();
  }, [isArchivedList]);

  const handleDelete = (el) => {
    toast.warning(
      <div>
        <p>Are you sure you want to delete?</p>
        <Button
          variant="success"
          className="btn-sm"
          onClick={() => deleteItem(el)}
        >
          Yes
        </Button>
        <Button
          variant="danger"
          className="btn-sm"
          style={{ marginLeft: "2px" }}
          onClick={closeToast}
        >
          No
        </Button>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  };

  const deleteItem = async (el) => {
    const resp = await authCall("deleteDailyDeal", {
        dailyDealId: el.id,
      isSoft: true,
    });
    if (resp?.type === "success") {
      closeToast();
      const updatedItems = goalList.filter((item) => item.id !== el.id);
      setGoalList(updatedItems);
      toast.success("Deleted successfully.");
    }
  };

  const closeToast = () => {
    toast.dismiss();
  };

  return (
    <>
      <div className="update-machine-page common-table-design py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-sm-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-sm-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">Archived Daily Deals</div>
                <div className="details-wrapper py-lg-4">
                  <div className="table-responsive">
                    <table className="table table-borderless table-custom m-0">
                      <thead>
                        <tr>
                          <th scope="col">Id:</th>
                          <th scope="col">Date:</th>
                          <th scope="col">Company:</th>
                          <th scope="col">Activity:</th>
                          <th scope="col">Prize One:</th>
                          <th scope="col">Quantity:</th>
                          <th scope="col">Remain Quantity:</th>
                          <th scope="col">Prize Two:</th>
                          <th scope="col">Quantity:</th>
                          <th scope="col">Remain Quantity:</th>
                          <th scope="col">Prize Three:</th>
                          <th scope="col">Quantity:</th>
                          <th scope="col">Remain Quantity:</th>
                          <th scope="col">Voucher:</th>
                          <th scope="col">Action:</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!loading &&
                          (goalList.length > 0 ? (
                            goalList.map((el, index) => (
                              <tr key={index}>
                                <td>#{el.id}</td>
                                <td>{el.deal_date}</td>
                                <td>{el.company}</td>
                                <td>{el?.activity?.activity_name}</td>
                                <td>{el.prize_one}</td>
                                <td>{el.prize_one_quantity}</td>
                                <td style={{color:"red"}}>{el.prize_one_quantity_remain}</td>
                                <td>{el.prize_two}</td>
                                <td>{el.prize_two_quantity}</td>
                                <td style={{color:"red"}}>{el.prize_two_quantity_remain}</td>
                                <td>{el.prize_three}</td>
                                <td>{el.prize_three_quantity}</td>
                                <td style={{color:"red"}}>{el.prize_three_quantity_remain}</td>
                                <td>
                                  <img
                                    src={el?.voucher}
                                    alt="el.event_photo"
                                    style={{ width: 80, borderRadius: 5 }}
                                  />
                                </td>
                                <td>
                                  <div className="icon-container">
                                    <Trash
                                      onClick={() => handleDelete(el)}
                                      className="cursor-pointer"
                                      style={{
                                        color: "red",
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={10} className="text-center">
                                No record found
                              </td>
                            </tr>
                          ))}
                        {loading && (
                          <tr>
                            <td colSpan={10} className="text-center">
                              Loading...
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ArchivesDailyDealsPage;
